<template>
  <div class="row">
    <div class="col-lg-12">
      <b-card header="<i class='fa fa-align-justify'></i> List Pengajuan Izin">
        <div v-if="isLoading" style="height: 20rem" class="d-flex align-items-center justify-content-center">
          <half-circle-spinner
            :animation-duration="1000"
            :size="60"
            :color="'#000000'"
          />
        </div>
        <transition name="fade" mode="out-in">
          <div v-if="!isLoading" class="">
            <div class="row">
              <div class="col-12">
                <div class="p-3 pull-right">
                  <router-link :to="'/pengajuan/header'" class="btn btn-success " title="Rekam permohonan izin"><i class="fa fa-plus"></i> Add New</router-link>
                </div>
              </div>
            </div>
            <div class="col-12" style="overflow-y:scroll;">
              <table class="table table-bordered">
                <thead>
                  <tr style="cursor: pointer">
                    <th @click="sort('NM_PERUSAHAAN')">Nama Perusahaan <i class="fa fa-arrows-v pull-right"></i> </th>
                    <th @click="sort('no_mohon')">No Mohon <i class="fa fa-arrows-v pull-right"></i></th>
                    <th @click="sort('tgl_mohon')">Tgl Mohon <i class="fa fa-arrows-v pull-right"></i></th>
                    <th @click="sort('nama_ijin')">Jenis Izin<i class="fa fa-arrows-v pull-right"></i></th>
                    <th @click="sort('status')">Status<i class="fa fa-arrows-v pull-right"></i></th>
                    <th></th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="bl in pageOfItems" :key="bl.id_rekon_manifes">
                    <td>{{bl.NM_PERUSAHAAN}}</td>
                    <td>{{bl.no_mohon}}</td>
                    <td>{{bl.tgl_mohon}}</td>
                    <td>{{bl.nama_ijin}}</td>
                    <td>{{bl.ur_status}}</td>
                    <!-- <td>
                      <router-link class="btn btn-primary" :to="'/brows/detilbrows/' + bl.id_permohonan" title="Detil Pengajuan"><i class="fa fa-search"></i></router-link>
                      <button title="Catatan Petugas" @click="opencatatan(bl.id_permohonan)" type="button" class="btn btn-success"><i class="fa fa-list-ul" ></i> </button>
                    </td> -->
                    <td>
                      <router-link class="btn btn-primary" :to="'/pengajuan/detilheader/' + bl.id_permohonan" title="Detil Pengajuan"><i class="fa fa-search"></i></router-link>
                      <button class="btn btn-danger" @click="confir(bl.id_permohonan)" title="Hapus Pengajuan"><i class="fa fa-trash-o"></i></button>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
            <div class="ml-3 pb-0 pt-3">
                <jw-pagination :items="filteredData" @changePage="onChangePage"></jw-pagination>
            </div> 
          </div>
        </transition>
      </b-card>
    </div>
  </div>
</template>
<script>
import swal from 'sweetalert'
import {HalfCircleSpinner} from 'epic-spinners'
export default {
  components: {HalfCircleSpinner},
  data () {
    return {
      pengajuan: [],
      isLoading: true,
      listBL: [],
      currentSort: 'wk_kirim',
      currentSortDir: 'asc',
      searchFilter: '',
      pageOfItems: []
    }
  },
  created () {
    this.getPengajuan()
  },
  computed: {
    // dataNhiFiltered () {
    //   return this.datanhi.filter((nhi) => {
    //     return this.searchFilter.toLowerCase().split(' ').every(v => nhi.no_container.toLowerCase().includes(v))
    //   })
    // },
    filteredData: function () {
      return this.pengajuan.sort((a, b) => {
        let modifier = 1
        if (this.currentSortDir === 'desc') modifier = -1
        if (a[this.currentSort] < b[this.currentSort]) return -1 * modifier
        if (a[this.currentSort] > b[this.currentSort]) return 1 * modifier
        return 0
      }).filter((items) => {
        for (var item in items) {
          if (String(items[item]).toLowerCase().indexOf(this.searchFilter.toLowerCase()) !== -1) {
            return true
          }
        }
        return false
      })
    }
  },
  methods: {
    sort: function (s) {
      // if s == current sort, reverse
      if (s === this.currentSort) {
        this.currentSortDir = this.currentSortDir === 'asc' ? 'desc' : 'asc'
      }
      this.currentSort = s
    },
    onChangePage (pageOfItems) {
    // update page of items
      this.pageOfItems = pageOfItems
    },
    getPengajuan (page) {
      if (typeof page === 'undefined') {
        page = 'pengajuanftz'
      }
      var auth = {
        user: this.$store.getters['auth/user']['username']
      }
      this.$http.post(page, auth)
        .then(response => {
          this.pengajuan = response.data
          this.isLoading = false
        })
    },
    confir (iddel) {
      swal({
        title: 'Hapus data permohonan',
        text: 'Anda yakin akan menghapus data ini?',
        icon: 'warning',
        buttons: {
          cancel: 'Cancel',
          Yes: 'Yes'
        }
      })
        .then((value) => {
          switch (value) {
            case 'Yes':
              this.deletePengajuan(iddel)
          }
        })
    },
    deletePengajuan (id) {
      var data = {
        user: this.$store.getters['auth/user']['username'],
        delid: id
      }
      this.$http.post('delete', data)
        .then(response => {
          swal(response.data.status, response.data.message, response.data.status)
          this.getPengajuan()
        })
    }
  }
}
</script>
<style lang="scss" scoped>
</style>



// WEBPACK FOOTER //
// src/views/Pengajuan/Pengajuan.vue?0bb0d04c